import React, { ChangeEvent } from 'react';
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';

import { textInputStyle } from '../themes/input';

const styles = (theme: Theme) => ({
  ...textInputStyle(theme),
});

type Props = WithStyles &
  TextFieldProps & {
    value: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    inputClasses?: string;
    multiline?: boolean;
    rows?: number;
    placeholder?: string;
    disabled?: boolean;
  };

const MHInput: React.FC<Props> = ({
  classes,
  InputProps,
  inputClasses = '',
  value,
  multiline,
  rows,
  onChange,
  placeholder,
  disabled,
}) => (
  <TextField
    margin="dense"
    variant="outlined"
    multiline={multiline}
    rows={rows}
    value={value}
    // Add type hint so that callers don't have to
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
    className={`${classes.textField} ${inputClasses}`}
    InputProps={InputProps}
    placeholder={placeholder}
    disabled={disabled}
  />
);

export default withStyles(styles)(MHInput);
